import Vue from 'vue'
import VueRouter from 'vue-router'
import VueCookies from 'vue-cookies'

Vue.use(VueRouter);

// pages
import Login from './components/pages/Login.vue'
import notFound from './components/pages/404.vue'

import News from './components/pages/News'
import Dashboard from './components/pages/Dashboard'
import BlockchainLive from './components/pages/BlockchainLive.vue'
import Summary from './components/pages/Summary.vue'
import Transactions from './components/pages/Transactions.vue'
import Indicators from './components/pages/Indicators.vue'
import Graph from './components/pages/Graph'
import Mempool from './components/pages/Mempool'
// import Screener from './components/pages/Screener.vue'
import Score from './components/pages/Score.vue'

const ifNotAuthenticated = (to, from, next) => {
    if (!VueCookies.get('auth')) {
      next()
      return
    }
    next('/')
  }
  
  const ifAuthenticated = (to, from, next) => {
    if (VueCookies.get('auth')) {
      next()
      return
    }
    next('/login')
  }

  const routes = [
    // inner pages
    { path: '/', component: News,  meta: {title: 'News' },beforeEnter: ifAuthenticated},
    { path: '/dashboard', component: Dashboard,  meta: {title: 'Dashboard' },beforeEnter: ifAuthenticated},
    { path: '/live', component: BlockchainLive,  meta: {title: 'Live' },beforeEnter: ifAuthenticated},
    { path: '/summary', component: Summary,  meta: {title: 'Summary' },beforeEnter: ifAuthenticated},
    { path: '/transactions', component: Transactions,  meta: {title: 'Transactions' },beforeEnter: ifAuthenticated},
    { path: '/indicators', component: Indicators,  meta: {title: 'Indicators' },beforeEnter: ifAuthenticated},
    { path: '/graph', component: Graph,  meta: {title: 'Graph' },beforeEnter: ifAuthenticated},
    { path: '/mempool', component: Mempool,  meta: {title: 'Mempool' },beforeEnter: ifAuthenticated},
    // { path: '/screener', component: Screener,  meta: {title: 'Screener' },beforeEnter: ifAuthenticated},
    { path: '/score', component: Score,  meta: {title: 'Score' },beforeEnter: ifAuthenticated},
  
    // outer pages
    { path: '/login', component: Login, meta: {title: 'Login' },beforeEnter: ifNotAuthenticated},
    { path: '*', component: notFound, meta: {title: 'Page not found' }},
  ]
  const router = new VueRouter({routes});
  
  // set document Title
  router.afterEach((to) => {
    document.title = to.meta.title
  })

  export default router;